import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import HeaderGridTemplate from "./header-template/header-grid";
import { DfpAd } from "../dfp-ad";
import headerConfig from "./header-config.json";
import { updateBodyScroll } from "../../utils";

export class HeaderBase extends React.Component {
  constructor(props) {
    super(props);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.closeAll = this.closeAll.bind(this);
    this.windowScroll = this.windowScroll.bind(this);
  }

  toggleSidebar() {
    updateBodyScroll(!this.props.header.isSidebarVisible, "remove-body-scroll-header");
    this.props.toggleSidebar();
  }

  closeAll() {
    updateBodyScroll(false, "remove-body-scroll-header");
    this.props.closeAll();
  }

  windowScroll() {
    window.scrollTo(0, 0);
  }

  render() {
    const headerConfigData =
      this.props.publisherTheme.header_theme && headerConfig[this.props.publisherTheme.header_theme]
        ? headerConfig[this.props.publisherTheme.header_theme]
        : headerConfig["header_1"];
    return (
      <React.Fragment>
        <div className="app-ad app-ad--leaderboard">
          <DfpAd adtype="Horizontal-Ad" layoutName="Navigation" />
        </div>
        <HeaderGridTemplate
          {...this.props}
          toggleSidebar={this.toggleSidebar}
          toggleSearchForm={this.props.toggleSearchForm}
          hideSearchForm={this.props.hideSearchForm}
          closeAll={this.closeAll}
          windowScroll={this.windowScroll}
          headerConfig={headerConfigData}
        />
      </React.Fragment>
    );
  }
}

HeaderBase.propTypes = {
  title: PropTypes.string,
  menu: PropTypes.array,
  publisherTheme: PropTypes.shape({
    logo: PropTypes.string,
    monogram: PropTypes.string,
    header_theme: PropTypes.string
  }),
  publisherName: PropTypes.string,
  socialLinks: PropTypes.shape({
    "facebook-url": PropTypes.string,
    "twitter-url": PropTypes.string
  }),
  header: PropTypes.shape({
    isSidebarVisible: PropTypes.bool,
    isSearchFormVisible: PropTypes.bool
  }),
  currentPath: PropTypes.string,
  toggleSidebar: PropTypes.func,
  hideSearchForm: PropTypes.func,
  toggleSearchForm: PropTypes.func,
  closeAll: PropTypes.func
};

const mapStateToProps = state => {
  return {
    title: get(state.qt, ["config", "publisher-settings", "title"], "Madrid"),
    menu: get(state.qt, ["data", "navigationMenu"], []),
    publisherTheme: get(state.qt, ["config", "theme-attributes"], {}),
    publisherName: get(state.qt, ["config", "publisher-name"], "Madrid"),
    socialLinks: get(state.qt, ["config", "social-links"], {}),
    header: state.header || {},
    currentPath: state.qt.currentPath,
    member: get(state, ["member"], null),
    isLoginOpen: get(state, ["isLoginOpen"], false)
  };
};

const mapDispatchToProps = dispatch => ({
  openLoginTemplate: () => dispatch({ type: "OPEN_LOGIN_TEMPLATE" }),
  closeLoginTemplate: () => dispatch({ type: "CLOSE_LOGIN_TEMPLATE" }),
  toggleSidebar: () => dispatch({ type: "TOGGLE_SIDEBAR_MENU" }),
  hideSearchForm: () => dispatch({ type: "CLOSE_SEARCHFORM" }),
  toggleSearchForm: () => dispatch({ type: "TOGGLE_SEARCHFORM" }),
  closeAll: () => dispatch({ type: "CLOSE_ALL" })
});

const Header = connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderBase);

export default Header;
